export default (phone) => {
    const reg = /(\d{3})(\d{3})(\d{4})/;
    if (phone.search(reg) > -1)
        return phone.replace(reg, "($1)$2-$3");
    return phone;
}